import PageTitleComponent from "../../components/PageTitle";
import Products from "../../components/Products";

export default function ProductsScreen(){
return <div>
    <PageTitleComponent title="Products" />
    <Products/>
</div>
}